/**
 * LEKI: Combo Variant Selector Handler
 *
 * Wires combo-pill radio inputs to the hidden per-option radio inputs that
 * theme.js and leki-mark-unavailable.js rely on.
 *
 * When a combo pill is selected:
 *   1. Finds the hidden [data-single-option-selector] radios for each option
 *   2. Checks them to reflect the selected variant's option values
 *   3. Fires a single `change` event on the last radio — this triggers:
 *        - theme.js ProductForm.onOptionChange → URL, price, images, button state
 *        - leki-mark-unavailable.js → "Currently Unavailable" state if applicable
 *
 * Uses event delegation on `document` so it works for:
 *   - Regular product pages (section renders on initial load)
 *   - Quick Buy / Quick View (AJAX-injected; inline scripts inside innerHTML are
 *     silently ignored by the browser, so this must be a standalone asset file)
 */
(function () {
  'use strict';

  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('combo-variant__input')) return;

    var input = e.target;
    var container = input.closest('[data-section-id]') || input.closest('[data-quick-view-inner]');
    if (!container) return;

    var productEl = container.querySelector('[data-product-json]');
    if (!productEl) return;

    var product;
    try { product = JSON.parse(productEl.textContent); } catch (err) { return; }

    var variantId = parseInt(input.value, 10);
    var variant = product.variants.find(function (v) { return v.id === variantId; });
    if (!variant) return;

    var lastChanged = null;
    variant.options.forEach(function (optVal, idx) {
      var sel = container.querySelector(
        '[data-single-option-selector][data-index="option' + (idx + 1) + '"]' +
        '[value="' + optVal.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]'
      );
      if (sel && sel.type === 'radio' && !sel.checked) {
        sel.checked = true;
        lastChanged = sel;
      }
    });

    if (lastChanged) {
      lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

}());